import React from "react";
import ReactDOM from "react-dom/client";
import EngineeringSquads from "./engineering-squads";
import "../../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <EngineeringSquads />
  </React.StrictMode>,
);
